import { render, staticRenderFns } from "./StarterFooter2.vue?vue&type=template&id=3736aa2f&"
import script from "./StarterFooter2.vue?vue&type=script&lang=js&"
export * from "./StarterFooter2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports